import React, { FC } from 'react'
import { colorStatus, DropdownComponent, StatusComponent } from 'LibNeo'
import {
	InterfaceElementModel,
	interfaceElementSlice,
	ItemsStatuses,
	ItemsStatusesMenu,
	RoleInterfaceElementModel,
} from 'Pages/interfaceElement'
import { useAppDispatch } from 'Src/hooks'
import { notifySlice } from 'Modules'
import { WrapperStatus } from 'Pages/interfaceElement/components/Grid/styled'

interface ComponentProps {
	item: InterfaceElementModel
}

const actions = {
	showMessage: notifySlice.actions.showNotify,
	open: interfaceElementSlice.actions.createOneRole,
	update: interfaceElementSlice.actions.updateOneRole,
	close: interfaceElementSlice.actions.deleteOneRole,
}

export const CustomColumnRole: FC<ComponentProps> = ({ item }) => {
	const { showMessage, open, update, close } = useAppDispatch(actions)

	const getStatus = (data): ItemsStatuses => {
		if (!data || data?.active === undefined) return ItemsStatuses.CLOSE
		if (data.active) return ItemsStatuses.OPEN
		return ItemsStatuses.INACTIVE
	}

	const listItemsStatusesClick = (key) => {
		const data = item?.active
		switch (key) {
			case ItemsStatuses.OPEN:
				if (data.roleElemId) {
					update({
						roleInterfaceElement: {
							id: data.roleElemId,
							role_id: data.role_id,
							interface_element_id: item.id,
							active: true,
						} as RoleInterfaceElementModel,
						id: data.roleElemId,
					})
				} else {
					open({
						role_id: data.role_id,
						interface_element_id: item.id,
						active: true,
					} as RoleInterfaceElementModel)
				}
				break
			case ItemsStatuses.INACTIVE:
				if (data.roleElemId) {
					update({
						roleInterfaceElement: {
							id: data.roleElemId,
							role_id: data.role_id,
							interface_element_id: item.id,
							active: false,
						} as RoleInterfaceElementModel,
						id: data.roleElemId,
					})
				} else {
					open({
						role_id: data.role_id,
						interface_element_id: item.id,
						active: false,
					} as RoleInterfaceElementModel)
				}

				break
			case ItemsStatuses.CLOSE:
				close(data.roleElemId)
				break
			default:
				break
		}
	}

	const disabledRoleStatus = !item?.active || !item?.active.role_id

	const ListItemsStatuses = [
		{
			id: ItemsStatuses.OPEN as string,
			name: ItemsStatusesMenu[ItemsStatuses.OPEN].text,
			onClick: () => listItemsStatusesClick(ItemsStatuses.OPEN),
		},
		{
			id: ItemsStatuses.INACTIVE as string,
			name: ItemsStatusesMenu[ItemsStatuses.INACTIVE].text,
			onClick: () => listItemsStatusesClick(ItemsStatuses.INACTIVE),
		},
		{
			id: ItemsStatuses.CLOSE as string,
			name: ItemsStatusesMenu[ItemsStatuses.CLOSE].text,
			onClick: () => listItemsStatusesClick(ItemsStatuses.CLOSE),
		},
	]

	return (
		<>
			{disabledRoleStatus ? (
				<WrapperStatus onClick={() => showMessage({ title: 'Для изменения выберите роль' })}>
					<StatusComponent
						title={ItemsStatusesMenu[getStatus(item?.active)].text}
						color={ItemsStatusesMenu[getStatus(item?.active)].color as colorStatus}
					/>
				</WrapperStatus>
			) : (
				<DropdownComponent
					list={ListItemsStatuses}
					wrappedComponent={
						<WrapperStatus>
							<StatusComponent
								title={ItemsStatusesMenu[getStatus(item?.active)].text}
								color={ItemsStatusesMenu[getStatus(item?.active)].color as colorStatus}
							/>
						</WrapperStatus>
					}
				/>
			)}
		</>
	)
}
